import { 
  extendedProjectPMRReportCardsInfo, 
  extendedProjectTCDIReportCardsInfo, 
  extendedReportCardsInfo 
} from "../../../../Reports/ExtemdedReport/variants/card-content";

export const getSections = (type: string, isPMRType: boolean) => {
  return type !== 'project' ? extendedReportCardsInfo
    : isPMRType ? extendedProjectPMRReportCardsInfo : extendedProjectTCDIReportCardsInfo;
}
